<h2>OPA Assignment</h2>
<div class="registrations__container">
  <div>
    <p>
      Below is a list of associated Originating Participating Aggregators, OPAs, selected by your organisation to accept and send your bulk sms messages to your customers. 
      When a SenderID Owner, SIDO, selects your organisation as their SMS Provider, these associated OPAs are notified. The association between your organisation and the  OPA(s) is not visible to the SIDO. 
      If you wish to amend this list, i.e. to add/remove associated OPA’s, please contact ComReg at <a href="mailto:industry.senderid&#64;comreg.ie">industry.senderid&#64;comreg.ie</a>
    </p>
    <br>
    <table mat-table matSort [dataSource]="dataSource" [fixedLayout]="true" >
      <ng-container matColumnDef="accountCode">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Account</th>
        <td mat-cell *matCellDef="let element" class="registrations__cell--accountcode">{{ element.accountCode }}</td>
      </ng-container>

      <ng-container matColumnDef="organisationName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Organisation</th>
        <td mat-cell *matCellDef="let element" >{{ element.organisationName }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columns"></tr>
      <tr mat-row *matRowDef="let row; columns: columns"></tr>
    </table>
  </div>
</div>
